// Autoryzacja: wlasny endpoint /login (JWT) zamiast Auth0.
// Token JWT w localStorage; axios dokleja Authorization: Bearer automatycznie.
// Po odpowiedzi 401 z backendu — auto-wylogowanie i redirect do /login.

import axios from 'axios';
import decode from 'jwt-decode';
import { API_URL } from './config';

const TOKEN_KEY = 'auth_token';

// --- Axios setup: dodaje token do kazdego requestu ---
function applyAuthHeader() {
  const t = getToken();
  if (t) axios.defaults.headers.common.Authorization = 'Bearer ' + t;
  else delete axios.defaults.headers.common.Authorization;
}
applyAuthHeader();

// Globalny interceptor: po 401 wyrzuc token i wroc do /login.
// Nie dotyczy samego /login (zeby nie bylo pętli przy zlym hasle).
axios.interceptors.response.use(
  r => r,
  err => {
    if (err && err.response && err.response.status === 401) {
      const url = (err.config && err.config.url) || '';
      if (!/\/login$/.test(url)) {
        localStorage.removeItem(TOKEN_KEY);
        applyAuthHeader();
        if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);

// --- Publiczne API ---

export function login(loginName, password) {
  return axios.post(API_URL + '/login', {
    login: String(loginName || '').trim().toLowerCase(),
    password: String(password || ''),
  }).then(res => {
    const token = res.data && res.data.token;
    if (!token) throw new Error('Brak tokenu w odpowiedzi');
    localStorage.setItem(TOKEN_KEY, token);
    applyAuthHeader();
    return res.data.user;
  });
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  applyAuthHeader();
  if (typeof window !== 'undefined') window.location.href = '/login';
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

function decodeToken() {
  const t = getToken();
  if (!t) return null;
  try {
    const d = decode(t);
    if (d.exp && d.exp * 1000 < Date.now()) return null;
    return d;
  } catch (e) {
    return null;
  }
}

export function isLoggedIn() {
  return decodeToken() !== null;
}

export function getLogin() {
  const d = decodeToken();
  return d ? d.login : '';
}

export function getRole() {
  const d = decodeToken();
  return d ? d.rola : null;
}

export function ifAdmin() {
  return getRole() === 'admin';
}

export function ifSprzedawca() {
  return getRole() === 'sprzedawca';
}

export function ifMagazyn() {
  return getRole() === 'magazyn';
}

// React Router v4 kompatybilnosc: nieuzywane jako onEnter, ale utrzymane
// jako helper do recznych przekierowan.
export function requireAuth(nextState, replace) {
  if (!isLoggedIn() && replace) replace({ pathname: '/login' });
}

// Zmiana wlasnego hasla — wywolujemy z komponentu ustawien.
export function changePassword(oldPassword, newPassword) {
  return axios.post(API_URL + '/changePassword', { oldPassword, newPassword });
}



// WEBPACK FOOTER //
// ./src/utils/AuthService.js